<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex'

const props = defineProps({
   violations: {
    type: Object,
    required: true
   } 
});

const store = useStore();

const loading = computed(() => store.state.globals.loading);
</script>

<template>
<b-overlay :show="loading">
    <div class="row m-3">
        <table class="table table-bordered table-sm table-light m-0">
            <tbody>
                <tr>
                    <th colspan="2" class="text-center">Violations</th>
                </tr>
                <tr v-for="(entry, index) in props.violations" :key="index">
                    <td>{{ entry.name ? entry.name : 'n/a' }}</td>
                    <td>{{ entry.penalty_fee ? entry.penalty_fee : 'n/a' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</b-overlay>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
th, td {
    background-color: #fff;
}
td{
  padding: 5px;
  text-align: center;
}
</style>
